import { render } from "./PasswordResetTemplate.vue?vue&type=template&id=2c69d80a"
import script from "./PasswordResetTemplate.vue?vue&type=script&lang=js"
export * from "./PasswordResetTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script